import { ROUTE_FROM_PEGNI, ROUTE_HOME, ROUTE_RICEVUTE } from "./frontendRouting"

export const breadcrumbHome = [
    { to: null, label: "HOME_BREADCRUMB_TITLE", ariaLabel:"HOME_BREADCRUMB_ARIALABEL", selected: true}
]

export const breadcrumbTrasmissionePegno = [
    { to: process.env.CONTEXT_PATH + ROUTE_FROM_PEGNI + ROUTE_HOME, label: "HOME_BREADCRUMB_TITLE", ariaLabel:"HOME_BREADCRUMB_ARIALABEL", selected: false}
    ,{ to: null, label: "TRASMISSIONE_PEGNO_BREADCRUMB_TITLE", ariaLabel:"TRASMISSIONE_PEGNO_BREADCRUMB_ARIALABEL", selected: true}
]

export const breadcrumbRicevutePegno = [
    { to: process.env.CONTEXT_PATH + ROUTE_FROM_PEGNI + ROUTE_HOME, label: "HOME_BREADCRUMB_TITLE", ariaLabel:"HOME_BREADCRUMB_ARIALABEL", selected: false}
    ,{ to: null, label: "RICEVUTE_PEGNO_BREADCRUMB_TITLE", ariaLabel:"RICEVUTE_PEGNO_BREADCRUMB_ARIALABEL", selected: true}
]

export const breadcrumbRicevutePegnoSecondoLivello = [
    { to: process.env.CONTEXT_PATH + ROUTE_FROM_PEGNI + ROUTE_HOME, label: "HOME_BREADCRUMB_TITLE", ariaLabel:"HOME_BREADCRUMB_ARIALABEL", selected: false}
    ,{ to: process.env.CONTEXT_PATH + ROUTE_FROM_PEGNI + ROUTE_RICEVUTE, label: "RICEVUTE_PEGNO_BREADCRUMB_TITLE", ariaLabel:"RICEVUTE_PEGNO_BREADCRUMB_ARIALABEL", selected: true}
]